var React = require('react');

function PersonIcon1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"d":"M374,10A168.27,168.27,0,1,1,255,59.28,168.27,168.27,0,0,1,374,10m0-10A178.28,178.28,0,1,0,552.31,178.31,178.28,178.28,0,0,0,374,0Z","key":0}),React.createElement("path",{"d":"M253.8,364.78A197.06,197.06,0,0,0,283.16,381a225.39,225.39,0,0,0,91.67,19.66c62.09,0,104.33-25.53,118.79-35.79l187.33,97A105.7,105.7,0,0,1,738,555.72v194H10V556.5a105.41,105.41,0,0,1,56.62-93.61l187.16-98.11m238.82-11.73s-44.53,37.57-117.79,37.57-120.2-37.57-120.2-37.57L62,454A115.69,115.69,0,0,0,0,556.47V759.72H748v-204A115.69,115.69,0,0,0,685.55,453L492.62,353.05Z","key":1})])));
}

PersonIcon1.defaultProps = {"viewBox":"0 0 748 759.72"};

module.exports = PersonIcon1;

PersonIcon1.default = PersonIcon1;
